import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';

import appI18n from '../../../../config/i18n';
import { Company } from '../../../../models/Company';

interface ContactCompaniesTagsProps {
  companyIds: number[];
  companies: Company[];
}

function ContactCompaniesTags({
  companyIds,
  companies,
}: ContactCompaniesTagsProps) {
  const { t } = useTranslation(undefined, { i18n: appI18n });

  if (!companyIds || companyIds.length === 0) {
    return (
      <Tag color="default">
        {t('scenes.settings.contacts.scene.table.company.all')}
      </Tag>
    );
  }

  return (
    <>
      {companyIds.map((companyId) => {
        const company = companies.find((record) => record.id === companyId);

        return (
          <Tag key={companyId} color="purple">
            {company ? company.name : companyId}
          </Tag>
        );
      })}
    </>
  );
}

export default ContactCompaniesTags;
